import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      enableBackground: "new 0 0 17 16",
    }}
    fill="#2c3e43"
    viewBox="0 0 17 16"
    {...props}
  >
    <path
      d="M6.7 8.9C4.5 6 2.3 3.1.1.1h4.8c.1 0 .1 0 .1.1.6.8 1.1 1.5 1.7 2.3.7 1 1.5 2 2.2 3 .2.1.3.3.4.5.1-.1.2-.3.4-.4.5-.6 1.1-1.2 1.6-1.7.7-.7 1.4-1.5 2-2.2.5-.5 1-1 1.4-1.5H16.1c-2 2.2-4.1 4.4-6.1 6.6 2.3 3 4.5 6 6.8 9.1H11.9s-.1 0-.1-.1c-.7-.9-1.3-1.8-2-2.7-.7-.9-1.4-1.9-2.1-2.8-.1-.2-.3-.4-.4-.6 0 .1-.1.1-.1.1C6 11 4.9 12.2 3.9 13.4c-.8.8-1.5 1.7-2.3 2.5H.2c2.1-2.4 4.3-4.7 6.5-7zm8 5.9c0-.1 0-.1 0 0-.6-.8-1.1-1.5-1.7-2.3-.6-.7-1.1-1.5-1.7-2.2-.7-1-1.4-1.9-2.1-2.9-.8-1-1.5-2-2.3-3-.8-1.1-1.6-2.1-2.4-3.2H2.2v.1c.1.1.2.3.3.4.8 1 1.5 2 2.3 3.1l1.8 2.4c.6.8 1.2 1.6 1.8 2.3.7 1 1.4 1.9 2.1 2.9l1.8 2.4.1.1c.8-.1 1.5-.1 2.3-.1z"
    />
  </svg>
)
export default SvgComponent